import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppButton = _resolveComponent("AppButton")!

  return (_openBlock(), _createElementBlock("li", null, [
    _createVNode(_component_AppButton, {
      class: "relative",
      size: "lg",
      color: "white",
      "full-width": true,
      loading: _ctx.loading,
      rounded: false
    }, {
      default: _withCtx(() => [
        (!!_ctx.logo)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: _ctx.logo,
              alt: _ctx.name,
              class: "absolute top-1/2 left-4 transform -translate-y-1/2 h-6"
            }, null, 8, _hoisted_1))
          : _createCommentVNode("", true),
        _createTextVNode(" " + _toDisplayString(_ctx.name), 1)
      ]),
      _: 1
    }, 8, ["loading"])
  ]))
}